var identity = {};
export {
  identity as __exports
};
//# sourceMappingURL=identity.js.map
